import axios from "axios";
import React, { use, useEffect, useState } from "react";
import './BulkOps.css'
import { FaCheck } from "react-icons/fa";
import { MdExpandLess,MdExpandMore ,MdExpandCircleDown} from "react-icons/md";
import { useNavigate } from "react-router-dom"; // Use useNavigate from v6
import {AlertModal} from "../components/AlertModal/AlertModal";
import ClipLoader from "react-spinners/ClipLoader";



export default function BulkOps() {

    const [domainNames, setDomainNames] = useState([])
    const [websites, setWebsites] = useState([]);
    const [users, setUsers] = useState({})
    const [data, setData] = useState({"competition":"", "period":"", "badge":""})
    const [replacedData, setReplacedData] = useState({"competition":"", "period":"", "badge":""})
    const [competitions] = useState(["TopWeb", "BestWeb"]);
    const [months,setMonths] = useState([]);
    const [years,setYears] = useState([]);
    const [fetchData, setFetchData] = useState("")
    const [awardTypes, setAwardTypes] = useState([]);
    const [badges,setBadges] = useState([]);
    const [redirectLinks, setRedirectLinks] = useState(["TopWeb.lk", "BestWeb.lk"])
    const [searchInput, setSearchInput] = useState("")
    const [bulk, setBulk] = useState([])
    // const [replaceBulk, setReplaceBulk] = useState({})
    const [isReplace, setIsReplace] = useState(false)
    const [isSelectAll, setIsSelectAll] = useState(false)
    const token = localStorage.getItem("token")
    const [showAlert, setShowAlert] = useState(false);
    const [message, setMessage] = useState("")
    const [color, setColor] = useState("")
    const [shouldReload, setShouldReload] = useState(false);
    const [loading, setLoading] = useState(false);

    const REACT_APP_ADMIN_API_URL = process.env.REACT_APP_ADMIN_API_URL;

    const navigate = useNavigate();

    useEffect(()=>{
      if(!token){
        navigate("/login")
      }
    },[token, navigate])

    useEffect(()=>{
      if(token){
        getDomainNames()
        getUsers()
        getBadges()
        getPeriods()
        getAwardTypes();
      }
    }, [token])


    const getDomainNames = async() => {
      try{
        const response = await axios.get(`${REACT_APP_ADMIN_API_URL}/api/v1/names`,
          {headers:{Authorization: `Bearer ${token}`}}
        )
        const names = response.data.map((domainName)=> domainName.name)
        setDomainNames(names)
        setWebsites(names)
      }
      catch(e){
        if(e.response?.status === 401){
          handleUnauthorized();
        }
        else{
          setShowAlert(true)
          setColor("red")
          setMessage("Error when fetching domain names")
        }
      }
    }

    const getPeriods = async()=>{
      try{
        const response = await axios.get(`${REACT_APP_ADMIN_API_URL}/api/v1/periods`,
          {headers:{Authorization: `Bearer ${token}`}}
        )
        // //console.log(response.data)
        response.data.map((period)=>{
          // //console.log(period)
          if(period.competition.id==1){
            setYears((prev)=>
              [...prev, period.name]
            )
          }
          else if(period.competition.id==2){
            setMonths((prev)=>
              [...prev, period.name]
            )
          }
        })
      }
      catch(e){
        if(e.response?.status === 401){
          handleUnauthorized();
        }
        else{
          setShowAlert(true)
          setColor("red")
          setMessage("Error when fetching periods")
        }
      }
    }

    const getAwardTypes = async() =>{
      try{
        const response = await axios.get(`${REACT_APP_ADMIN_API_URL}/api/v1/awardTypes`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const types = response.data.map((type) => type.name);
        setAwardTypes(types);
      } catch (e) {
        if (e.response?.status === 401) {
          //console.log("Unauthorized when fetching badges");
          handleUnauthorized();
          return
        } else {
          //console.log("Error when loading award types");
          //console.log(e);
        }
      }
    }

    const getBadges = async()=>{
      try{
        const response = await axios.get(`${REACT_APP_ADMIN_API_URL}/api/v1/badge-store`,
          {headers: {Authorization : `Bearer ${token}`}}
        )
        const badges = response.data.map(badge=>badge.name)
        setBadges(badges)
      }
      catch(e){
        if(e.response?.status === 401){
          handleUnauthorized()
        }
        else{
          setShowAlert(true)
          setColor("red")
          setMessage("Error when loading badges")
        }
      }
    }

    const getUsers = async () =>{
        //console.log("Data fetched...")
        try{
          const result = await axios.get(`${REACT_APP_ADMIN_API_URL}/api/v1`,
            {headers:{Authorization: `Bearer ${token}`}}
          );
          
          const websiteNames = []
          let dic ={}
          result.data.forEach(user=>
              {if(!websiteNames.includes(user.name)) {
                  websiteNames.push(user.name)
              }
              if(!dic[user.name]){
                dic[user.name] = []
              }
              dic[user.name].push(
                {
                  id: user.id || "",
                  competition: user.competition || "",
                  period: user.period || "",
                  badge: user.badge || "",
                  redirectLink: user.redirectLink || "",
                  awardType : user.awardType || ""
                }
              )
            
            }
          )
          setUsers(dic)
        }
        catch(e){
          if(e.response?.status === 401){
            handleUnauthorized()
          }
          else{
            setShowAlert(true)
            setColor("red")
            setMessage("Error fetching users")
          }
        }
        
    }

    const handleBulk = (website) => {
        setBulk((prev) => {
          if (prev.includes(website)) {
            // If website is already selected, remove it
            return prev.filter((item) => item !== website);
          } else {
            // If not selected, add it
            return [...prev, website];
          }
        });
      };

    const handleSearch = () =>{
        setIsSelectAll(false)
        // const websiteNames = []
        // Object.keys(users).forEach(user =>{
        //   if(!websiteNames.includes(user)){
        //     websiteNames.push(user)
        //   }
        // })

        const TrimmedInput = searchInput.trim()

        if(!TrimmedInput){
          setWebsites(domainNames)
          return
        }
        //console.log(TrimmedInput)
        const filtered = domainNames.filter((user)=>
            {
                if(user.match(TrimmedInput)){
                    return(TrimmedInput)
                }
                
            }
        )
        setWebsites(filtered)
    }

    const handleAdd = async () => {
      
      data.redirectLink  = data.redirectLink.trim()

      if (data.redirectLink == "") {
        setShowAlert(true)
        setColor("red")
        setMessage("Redirect Link is empty");
        return;
      }
      if (bulk.length === 0) {
        setShowAlert(true)
        setColor("red")
        setMessage("Please select domain names to add this record");
        return;
      }
    
      

      let dic = {};
      bulk.forEach(name => {
        dic[name] = [{
          name: name,
          competition: data.competition || "",
          period: data.period || "",
          badge: data.badge || "",
          redirectLink: data.redirectLink || "",
          awardType: data.awardType || ""
        }];
      });
    
      let added = "";
    
      const promises = Object.keys(dic).map(async (user) => {
        try {
          const response = await axios.post(`${REACT_APP_ADMIN_API_URL}/api/v1`, dic[user][0],
            { headers: { Authorization: `Bearer ${token}` } });

          if(response.status === 200 || response.status === 201){
            added += user+", ";
          }
        } catch (error) {
          if (error.response?.status === 409) {
            //console.log("That record has already been assigned to " + user);
          } else if (error.response?.status === 401) {
            handleUnauthorized();
          } else {
            //console.log("An unexpected error occurred. Please try again.");
          }
        }
      });
    
      await Promise.all(promises); //Wait for all axios calls to complete
      setShowAlert(true)
      if(added.trim()===""){
        setColor("red")
        setMessage("The selected domain names already have this record.")
      }
      else{
        setColor("green")
        setShouldReload(true); // <- tell the modal we want to reload
        setMessage("Record added to " + added);
      }
      
    }
    
    const handleSelectAll = () =>{

      if(!isSelectAll){
        setIsSelectAll(true)
        setBulk(websites)
      }
      else {
        setIsSelectAll(false)
        setBulk([])
      }
    }

    const handleReplace = async () =>{

      replacedData.redirectLink = replacedData.redirectLink.trim()
      data.redirectLink = data.redirectLink.trim()
      
      if(replacedData.redirectLink == ""){
        setShowAlert(true)
        setColor("red")
        setMessage("Redirect Link is empty")
        return
      }
      if (data.redirectLink == "") {
        setShowAlert(true)
        setColor("red")
        setMessage("Redirect Link is empty");
        return;
      }

      if(replacedData.competition==data.competition && replacedData.period == data.period && replacedData.awardType == data.awardType && replacedData.badge == data.badge  && replacedData.redirectLink == data.redirectLink){
        setShowAlert(true)
        setColor("red")
        setMessage("The new record is the same as the existing one. No changes have been made");
        return;
      }

      let replaceBulk = {}
      Object.keys(users).forEach(user=>{
        
        users[user].forEach(item=>{
          // //console.log(item)
          if(item.competition==data.competition && item.period == data.period && item.awardType == data.awardType && item.badge == data.badge  && item.redirectLink == data.redirectLink){
            replaceBulk[user] = item.id
          }
        })
      })
      if(Object.keys(replaceBulk).length==0){
        setShowAlert(true)
        setColor("red")
        setMessage("The selected record does not exist and cannot be replaced")
        // navigate(0)
        return
      }

      
      
      let dic= {}
      Object.keys(replaceBulk).forEach(name=>{
        dic[name] = []
        dic[name].push({
          id: replaceBulk[name],
          name: name,
          competition: replacedData.competition || "",
          period: replacedData.period || "",
          awardType : replacedData.awardType || "",
          badge: replacedData.badge || "",
          redirectLink: replacedData.redirectLink || ""
        })
      })


      let added = []


      const promises = Object.keys(dic).map(async user=>{
        // //console.log(dic[user][0])
        try{
          const response = await axios.put(`${REACT_APP_ADMIN_API_URL}/api/v1`, dic[user][0],
            {headers:{Authorization: `Bearer ${token}`}})

          if (response?.status === 200 || response?.status === 201){
            added.push(user)
          }
        }
        catch(error){
          
          if(error.response?.status === 401){
            handleUnauthorized()
          }
        }
      })

      await Promise.all(promises)

      setShowAlert(true)
      if(added.length===0){
        setColor("red")
        setMessage("Record(s) with the new values already exist. No changes were made.")
      }
      else if(added.length===1){
        setColor("green")
        setShouldReload(true)
        setMessage("Successfully replaced the record for " + added[0])
      }
      else{
        setColor("green")
        let beforeText = ""
        for(let i = 0 ; i < (added.length - 1) ; i++){
          beforeText += "'" + added[i] + "', "
        }
        let afterText = added[added.length - 1]

        setShouldReload(true)
        setMessage("Successfully replaced the records for "+ beforeText +" and '"+ afterText +"'")
      }
     
    }
    const handleMore = ()=>{

      if (data.redirectLink.trim() == "") {
        setShowAlert(true)
        setColor("red")
        setMessage("Redirect Link is empty");
        return;
      }
      setIsReplace(prev => !prev)
    }

    const handleUnauthorized = ()=>{
      localStorage.removeItem("token")
      //console.log("Session expired. Please log in again.");
      navigate("/login");
    }

    const handleFetch = async () =>{

      const isValid = /^\d{4}$/.test(fetchData);

      if(!isValid){
        setShowAlert(true)
        setColor("red")
        setMessage("Not a valid year")
        return
      }


      try{
        setLoading(true);
        const response = await axios.post(`${REACT_APP_ADMIN_API_URL}/api/v1/names/add`,
            { year: fetchData },
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            })

        if( response?.status === 200 || response?.status === 201){
          setFetchData("")

          setShowAlert(true)
          setColor("green")
          setShouldReload(true)
          setMessage(response.data)
        }
      }
      catch(error){
        if(error.response?.status === 409){
          setShowAlert(true)
          setColor("red")
          setMessage(error.response.data)
        }
        else{
          setShowAlert(true)
          setColor("red")
          setMessage("Unexpected Error")
        }
      } 
      finally {
        setLoading(false);
      }

    }


    return(
        
        <div className="form-container" style={{ paddingTop: "60px", marginLeft:50, marginRight:50}}>
          {/* {console.log(websites, domainNames)} */}
          {showAlert && (
        <AlertModal
          message={message}
          color={color}
          onClose={() => {
            setShowAlert(false)
            setMessage("")
            setColor("")
            if(shouldReload){
              setShouldReload(false)
              navigate(0);
            }
          }}
        />
      )}

        {loading && <ClipLoader color="#3b82f6" />}

      <div style={{ display: "flex", alignItems: "center", gap: "50px", marginTop: "20px", marginBottom:"100px" }}>
          <span style={{ color: "white", fontWeight: "bold" }}>Fetch Domains :</span>

          <input
            type="text"
            value={fetchData}
            onChange={(e) => setFetchData(e.target.value.trim())}
            placeholder="Enter the year"
            className="form-control"
            style={{ width: "300px" }}
          />

          <button
            disabled={!fetchData}
            type="button"
            onClick={() => handleFetch()}
            className="btn btn-outline-success"
          >
            Fetch
          </button>
        </div>

            <div className="form-row">
            <select
                className="form-select"
                // style={{ width: "1300px" }}
                value={data.competition || ""}
                onChange={(e) => {
                  setData(prev => ({
                    ...prev, competition : e.target.value, period:""
                  }))
                }}
              >
                <option value="">Select Competition</option>
                {competitions.map((competition, j) => (
                  <option key={j} value={competition}>
                    {competition}
                  </option>
                ))}
              </select>
         
              <select
              // style={{ width: "1300px" }}
                className="form-select"
                value={data.period || ""}
                onChange={(e) => {
                  setData(prev => ({
                    ...prev, period:e.target.value
                  }))
                }}
                disabled={!data.competition}
              >
                <option value="">Select Time period</option>
                {(data.competition === "TopWeb" ? months : years).map(
                  (period, k) => (
                    <option key={k} value={period}>
                      {period}
                    </option>
                  )
                )}
              </select>

              <select
                // style={{ width: "1300px" }}
                className="form-select"
                value={data.awardType || ""}
                onChange={(e) => {
                  setData(prev => ({
                    ...prev, awardType: e.target.value
                  }))
                }}
                disabled={!data.period}
              >
                <option value="">Select Award Type</option>
                {awardTypes.map((type, l) => (
                  <option key={l} value={type}>
                    {type}
                  </option>
                ))}
              </select>
           
              <select
                // style={{ width: "1300px" }}
                className="form-select"
                value={data.badge || ""}
                onChange={(e) => {
                  setData(prev => ({
                    ...prev, badge: e.target.value
                  }))
                }}
                disabled={!data.awardType}
              >
                <option value="">Select Badge</option>
                {badges.map((badge, l) => (
                  <option key={l} value={badge}>
                    {badge}
                  </option>
                ))}
              </select>

              <input
              // style={{ width: "1300px" }}
                className="form-control"
                value={data.redirectLink || ""}
                onChange={(e) => {
                  setData(prev => ({
                    ...prev, redirectLink:e.target.value
                  }))
                }}
                disabled={!data.badge}
                placeholder="Enter redirect link"
              />
              
                <button
                
                onClick={() => handleAdd()}
                type="button"
                className="btn btn-outline-success uniform-btn "
                disabled={!data.competition ||!data.period || !data.awardType ||!data.badge ||!data.redirectLink || isReplace}> Add </button>
               <button
                    style={{
                        marginLeft: 5,
                        display: "flex", // Ensure the button is a flex container
                        alignItems: "center", // Center content vertically
                        justifyContent: "center", // Center content horizontally
                    }}
                    onClick={() => handleMore()}
                    type="button"
                    className="btn btn-outline-primary"
                    disabled={!data.competition ||!data.period || !data.awardType ||!data.badge ||!data.redirectLink}
                >
                    {!isReplace ? (
                        <h6
                            style={{
                                whiteSpace: "nowrap",
                                display: "flex", // Make h6 a flex container
                                alignItems: "center", // Center text and icon vertically
                                justifyContent: "center", // Center text and icon horizontally
                                margin: 0, // Remove default margin from h6
                                gap: "5px", // Add space between text and icon
                            }}
                        >
                            More
                            <MdExpandCircleDown />
                        </h6>
                    ) : (
                        <h6
                            style={{
                                whiteSpace: "nowrap",
                                display: "flex", // Make h6 a flex container
                                alignItems: "center", // Center text and icon vertically
                                justifyContent: "center", // Center text and icon horizontally
                                margin: 0, // Remove default margin from h6
                                gap: "5px", // Add space between text and icon
                            }}
                        >
                            More
                            <MdExpandLess />
                        </h6>
                    )}
                </button>
              </div>
              {isReplace ? (
              <div className="form-row">
              <select
                  // style={{ width: "1300px" }}
                  className="form-select"
                  value={replacedData.competition || ""}
                  onChange={(e) => {
                    setReplacedData(prev => ({
                      ...prev, competition : e.target.value, period:""
                    }))
                  }}
                >
                  <option value="">Select Competition</option>
                  {competitions.map((competition, j) => (
                    <option key={j} value={competition}>
                      {competition}
                    </option>
                  ))}
                </select>
           
                <select
                  // style={{ width: "1300px" }}
                  className="form-select"
                  value={replacedData.period || ""}
                  onChange={(e) => {
                    setReplacedData(prev => ({
                      ...prev, period:e.target.value
                    }))
                  }}
                  disabled={!replacedData.competition}
                >
                  <option value="">Select Time period</option>
                  {(replacedData.competition === "TopWeb" ? months : years).map(
                    (period, k) => (
                      <option key={k} value={period}>
                        {period}
                      </option>
                    )
                  )}
                </select>

                <select
                // style={{ width: "1300px" }}
                  className="form-select"
                  value={replacedData.awardType || ""}
                  onChange={(e) => {
                    setReplacedData(prev => ({
                      ...prev, awardType: e.target.value
                    }))
                  }}
                  disabled={!replacedData.period}
                >
                  <option value="">Select Award Type</option>
                  {awardTypes.map((type, l) => (
                    <option key={l} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
             
                <select
                // style={{ width: "1300px" }}
                  className="form-select"
                  value={replacedData.badge || ""}
                  onChange={(e) => {
                    setReplacedData(prev => ({
                      ...prev, badge: e.target.value
                    }))
                  }}
                  disabled={!replacedData.awardType}
                >
                  <option value="">Select Badge</option>
                  {badges.map((badge, l) => (
                    <option key={l} value={badge}>
                      {badge}
                    </option>
                  ))}
                </select>

                <input
                // style={{ width: "1300px" }}
                  className="form-control"
                  value={replacedData.redirectLink || ""}
                  onChange={(e) => {
                    setReplacedData(prev => ({
                      ...prev, redirectLink: e.target.value
                    }))
                  }}
                  disabled={!replacedData.badge}
                  placeholder="Enter redirect link"
                />

                 <button
                 style={{ width: "180px"}}
                  onClick={() => handleReplace()}
                  type="button"
                  className="btn btn-outline-primary uniform-btn "
                  disabled={!replacedData.awardType || !replacedData.competition || !replacedData.period || !replacedData.badge || !replacedData.redirectLink ||
                    !data.competition ||!data.period || !data.awardType ||!data.badge
                  }> Replace </button>             
                </div>):null
            }

              {!isReplace?(
                <div>              
              <div className="search-container" style={{marginLeft:0, marginTop:80, marginBottom:50}}>
                <input
                    type="text"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                    placeholder="Search by website name..."
                    className="search-input"
                />
                <button className="search-icon"  onClick={()=>handleSearch()}>
                    Search
                </button>
                </div>
                 <div style={{ display: "flex", alignItems: "center", textAlign: "left", marginLeft: 1 }}>
                <h6 style={{ color: "white", display: "flex", alignItems: "center", marginBottom: 0 }}>
                  <FaCheck style={{ marginRight: "15px" }} />
                  Select your list :
                </h6>
                <button 
                  onClick={() => handleSelectAll()}  
                  type="button" 
                  className="btn btn-outline-success uniform-btn" 
                  style={{ marginLeft: "50px" }}  // Adjust margin for proper spacing
                >
                  {(!isSelectAll || bulk.length==0)? "Select All": "Unselect All"}
                </button>
              </div>

                <div
                    style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
                    gap: "20px",
                    marginTop: "30px",
                    }}
                >
                    {websites.map((website, index) => (
                    <div
                    key={index}
                    style={{
                      backgroundColor: "transparent", // Transparent inside
                      color: "white",
                      padding: "10px",
                      borderRadius: "5px",
                      textAlign: "center",
                      fontSize: "15px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      border: "1px solid white" // White border
                    }}
                  >
                  
                        <button
                            onClick={()=>handleBulk(website)}
                            style={{
                                backgroundColor: "transparent", // Match tile background
                                border: "none", // Remove borders
                                color: "inherit", // Match tile text color
                                padding: 0, // Remove default button padding
                                fontSize: "inherit", // Match tile font size
                                display: "flex", // Use flex to align icon and text
                                alignItems: "center", // Vertically center
                                justifyContent: "center", // Horizontally center
                                gap: "8px", // Space between text and icon
                                width: "100%", // Ensure button fills the tile
                                cursor: "pointer", // Show pointer on hover
                            }}
                            >
                            <span>{website}</span>
                        {bulk.includes(website)?(<FaCheck style={{ marginLeft: "18px" }} />):null}
                        </button>
                    </div>
                    ))}
                </div>
                </div>
              ):null}
                
              </div>
              
              

    )
}

